import { Button, Form, InputNumber, Modal, Switch } from 'antd'
import React from 'react'

export const LPSettingsModal = ({ config, setConfig, isModalVisible, setIsModalVisible }) => {
  return (
    <Modal
      title='LP Settings'
      visible={isModalVisible}
      onOk={() => setIsModalVisible(false)}
      onCancel={() => setIsModalVisible(false)}
    >
      <div className='store-expand-card p-3'>
        <Form name='model_config' onFinish={(values) => setConfig(values)}>
          <Form.Item label='MIP Gap' name='mip_gap'>
            <InputNumber defaultValue={config.mip_gap} />
          </Form.Item>
          <Form.Item label='Timeout' name='model_timeout'>
            <InputNumber defaultValue={config.model_timeout} />
          </Form.Item>
          <Form.Item label='Linearize' name='linearize'>
            <Switch defaultChecked={config.linearize} />
          </Form.Item>
          <Form.Item label='Linearize After' name='linear_after'>
            <InputNumber defaultChecked={config.linear_after} />
          </Form.Item>
          <Form.Item label='Reprocess Scheduled Trips' name='reprocess_scheduled_trips'>
            <Switch defaultChecked={config.reprocess_scheduled_trips} />
          </Form.Item>
          <Form.Item>
            <Button type='primary' htmlType='submit'>
              Save
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  )
}
